<template>
  <div class="today-page">

    <!-- <h2>Today</h2> -->
    <!-- <OptimizerSidebar /> -->
    <!--
    <TodayCommitmentsAndGoals />

    <router-link to='/today/priorities' tag="el-button" type="primary" plain class="d-block w-100 mt-4">
      <font-awesome-icon icon="balance-scale" /> Set priorities
    </router-link>
    -->
    <DayplannerEditor />
  </div>
</template>

<script>
// import OptimizerSidebar from '@/components/CalendarPage/Legacy/Sidebar/OptimizerSidebar'
// import VisualAnalysis from '@/components/CalendarPage/Legacy/Sidebar/VisualAnalysis'
// import TodayCommitmentsAndGoals from '@/components/TodayPage/Mockup/TodayCommitmentsAndGoals'
import DayplannerEditor from "@/components/TodayPage/DayplannerEditor"

export default {
  name: "MyDay_Subpage",
  data: () => ({
  }),
  methods: {
  },
  components: {
    DayplannerEditor,
    // TodayCommitmentsAndGoals,
    // OptimizerSidebar,
    // VisualAnalysis
  }
}
</script>

<style>
</style>
